var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PLATFORM, ProductType, SOURCE } from "./interfaces";
import { mtGetUserInfo } from '@max/meituan-uni-userInfo';
// import { getSystemInfo } from '@max/meituan-uni-system';
// import { mtLogin } from '@max/meituan-uni-login';
// import { MtGetUserInfoResult } from '@max/meituan-uni-userInfo/types/types';
import dayjs from 'dayjs';
import { getHTCityId } from "./location/index.web";
import { CLIENT_CONTAINER, CLIENT_PLATFORM } from "@lowcode/mcp-protocol/src/base/common";
import { COMMODITY_INFO_CONFIG } from "../type/feConfig";
function getUser() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            mtGetUserInfo().then((res) => {
                resolve({
                    userId: res.userId,
                    uuid: res.uuid
                });
            }).catch(err => {
                // mtLogin()
                //   .then((res) => {
                //     //表示登录成功，做登录成功的事情
                //     console.log('\n\n 登录成功', res.token);
                //   })
                //   .catch((err) => {
                //     //登录失败，可能是用户取消等原因
                //     console.log('\n\n 登录失败', err);
                //   });
                resolve({
                    userId: -1,
                    uuid: ''
                });
            });
        });
    });
}
function getDate(props) {
    var _a, _b, _c;
    let checkInDate = (_a = props === null || props === void 0 ? void 0 : props.$global) === null || _a === void 0 ? void 0 : _a.getState('checkInDate');
    let checkOutDate = (_b = props === null || props === void 0 ? void 0 : props.$global) === null || _b === void 0 ? void 0 : _b.getState('checkOutDate');
    checkInDate = (_c = checkInDate === null || checkInDate === void 0 ? void 0 : checkInDate.replace(/-/g, '')) !== null && _c !== void 0 ? _c : dayjs(new Date().getTime()).format('YYYYMMDD');
    checkOutDate = checkOutDate ? dayjs(Date.parse(checkOutDate) - 24 * 60 * 60 * 1000).format('YYYYMMDD') : dayjs(new Date().getTime()).format('YYYYMMDD');
    return {
        checkInDate,
        checkOutDate
    };
}
const getRequestPlatform = (platform) => {
    let result = PLATFORM.MEITUAN;
    if (platform === CLIENT_PLATFORM.DP) {
        result = PLATFORM.DIANPING;
    }
    return result;
};
const getRequestSource = (clientContainer) => {
    let result = SOURCE.MEITUAN_APP;
    switch (clientContainer) {
        case CLIENT_CONTAINER.DIANPING_APP:
        case CLIENT_CONTAINER.DIANPING_WEBVIEW:
            result = SOURCE.DIANPING_APP;
            break;
        case CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM:
            result = SOURCE.MEITUAN_MINIAPP;
            break;
        case CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM:
            result = SOURCE.HOTEL_MINIAPP;
            break;
        case CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM:
            result = SOURCE.DIANPING_MINIAPP;
            break;
        default:
            break;
    }
    return result;
};
// const getRequestClientType = (clientContainer: CLIENT_CONTAINER, os: CLIENT_OS) => {
//   if (
//     [
//       CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM,
//       CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM,
//       CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM,
//     ].indexOf(clientContainer) > -1
//   ) {
//     return BASE_CLIENT_TYPE.WX;
//   }
//   if (os === CLIENT_OS.ANDROID) {
//     return BASE_CLIENT_TYPE.ANDROID;
//   }
//   if (os === CLIENT_OS.HARMONY) {
//     return BASE_CLIENT_TYPE.HARMONY;
//   }
//   return BASE_CLIENT_TYPE.IPHONE;
// };
export const commonParams2RequestParams = (commonParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { userId, token, uuid, platform, appVersion, clientContainer, cityInfo, 
    // os,
    lat = 0, lng = 0 } = commonParams !== null && commonParams !== void 0 ? commonParams : {};
    const result = {
        userId,
        token,
        platform: getRequestPlatform(platform),
        source: getRequestSource(clientContainer),
        uuid,
        clientVersion: appVersion,
        locationCityId: (cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) && Number(cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) > 0 ? Number(cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) : undefined,
        // clientType: getRequestClientType(clientContainer, os),
        position: `${lng},${lat}`
    };
    return Promise.resolve(result);
});
export default function getParams(pageNo, cityId, props, commonParams) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const hotelHomePageCityId = yield getHTCityId();
        const { checkInDate, checkOutDate } = getDate(props);
        const previewId = ((_a = props === null || props === void 0 ? void 0 : props.$global) === null || _a === void 0 ? void 0 : _a.getState('previewId')) || 1;
        if (props.commodityInfoConfig === COMMODITY_INFO_CONFIG.SUPPLY_ID) {
            const commonReqParams = yield commonParams2RequestParams(commonParams);
            // 供给ID上传方式 - 请求新接口
            return new Promise((resolve, reject) => 
            // @ts-ignore
            resolve(Object.assign(Object.assign({}, commonReqParams), { productGroupId: props.supplyId || 0, filterByCity: false, fallback: false, pageNo: pageNo + 1, 
                // 新接口从1开始,
                pageSize: props.pageSize, indexCityId: Number(hotelHomePageCityId), startDay: checkInDate, endDay: checkOutDate, cityId })));
        }
        else {
            // Excel导入和输入框录入方式 - 保持原有逻辑
            // TODO: 因为后端接口原因，idList目前仍为·需要·为number[]类型，等待API治理后再更改
            let idList = ((_b = props === null || props === void 0 ? void 0 : props.idList) === null || _b === void 0 ? void 0 : _b.length) ? (_d = (_c = props === null || props === void 0 ? void 0 : props.idList) === null || _c === void 0 ? void 0 : _c.split(',')) === null || _d === void 0 ? void 0 : _d.map(i => Number(i)) : [];
            return new Promise((resolve, reject) => {
                var _a, _b;
                return resolve({
                    productIdList: idList,
                    productType: ProductType.HotelPOI,
                    // 直接使用商品ID查询，productType不能为空
                    productGroupId: ((_a = props === null || props === void 0 ? void 0 : props.productBatchData) === null || _a === void 0 ? void 0 : _a.productGroupId) || 0,
                    batchId: ((_b = props === null || props === void 0 ? void 0 : props.productBatchData) === null || _b === void 0 ? void 0 : _b.batchId) || 0,
                    filterByCity: props.filterByCity && props.commodityInfoConfig === COMMODITY_INFO_CONFIG.PRODUCT_BATCH_DATA,
                    fallback: false,
                    pageNo: pageNo,
                    pageSize: props.pageSize,
                    indexCityId: Number(hotelHomePageCityId),
                    previewId,
                    version_name: commonParams === null || commonParams === void 0 ? void 0 : commonParams.appVersion,
                    uuid: (commonParams === null || commonParams === void 0 ? void 0 : commonParams.uuid) || '',
                    userid: commonParams === null || commonParams === void 0 ? void 0 : commonParams.userId,
                    cityId,
                    startDay: checkInDate,
                    endDay: checkOutDate,
                    pictureModifyParam: '',
                    token: commonParams === null || commonParams === void 0 ? void 0 : commonParams.token,
                    userId: commonParams === null || commonParams === void 0 ? void 0 : commonParams.userId
                });
            });
        }
    });
}
